import { IoMdClose } from "react-icons/io";
import { Title, Container, Select, Checkbox } from "components/Form";
import useT from "utils/hooks/useT"

export default function AnalysisTaskBundleSetup({
  index,
  tasks,
  onDelete,
  selectedTasks,
  cdmo,
  onSelectedTasksChange,
  onCdmoChange,
}) {
  const allTasksArray = Object.values(tasks);
  const { t } = useT("common")

  // "deduplicatedTasks" => unique by name
  const deduplicatedTasks = [];
  allTasksArray.forEach((task) => {
    const alreadyExists = deduplicatedTasks.some((t) => t.name === task.name);
    if (!alreadyExists) {
      deduplicatedTasks.push({ id: task.id, name: task.name });
    }
  });

  // Sort them alphabetically by name
  const taskNameObjectsSorted = deduplicatedTasks.sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  const handleSelectionChange = (newSelected) => {
    // If nothing is selected or the event is not an array, clear everything.
    if (!Array.isArray(newSelected) || newSelected.length === 0) {
      onSelectedTasksChange([]);
      return;
    }

    // 1) From each selected ID, gather the associated task *names*.
    const selectedNames = new Set();
    newSelected.forEach((id) => {
      const matchingTask = allTasksArray.find((t) => t.id === id);
      if (matchingTask) {
        selectedNames.add(matchingTask.name);
      }
    });

    // 2) Find all tasks that share any of those names.
    const finalSelectedTasks = allTasksArray
      .filter((task) => selectedNames.has(task.name))
      .map((task) => task.id);

    // 3) Update state with all tasks of those names.
    onSelectedTasksChange(finalSelectedTasks);
  };

  return (
    <div className="bundle-container-compartment">
      <p>{t("analysisTaskBundle", { index })}</p>
      <Container>
        <IoMdClose
          className="remove-asset-btn"
          title={t("removeAsset")}
          onClick={() => onDelete()}
        />
        <Title>{t("analysisTasksToBundle")}</Title>
        <Select
          name={t("analysisTasksToBundle")}
          collection={taskNameObjectsSorted}
          value={selectedTasks}
          onChange={handleSelectionChange}
          menuPosition="fixed"
        />
      </Container>
      <Container>
        <Title>{t("cdmoTargetedBundle")}</Title>
        <Checkbox
          checked={Boolean(cdmo)}
          id={`bundle-cdmo-${index}`}
          onChange={onCdmoChange}
        />
      </Container>
    </div>
  );
}
